module.exports = __webpack_public_path__ + "img/red-down-arrow.20669387.svg";